/*!
 * Flickity PACKAGED v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */
!function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(t,require('jquery')):t.jQueryBridget=e(t,t.jQuery);
}(window,(function(t,e){
  let i=t.console,s=void 0===i?function(){}:function(t){
    i.error(t);
  };return function(i,n,o){
    (o=o||e||t.jQuery)&&(n.prototype.option||(n.prototype.option=function(t){
      t&&(this.options=Object.assign(this.options||{},t));
    }),o.fn[i]=function(t,...e){
      return'string'==typeof t?function(t,e,n){
        let l,r=`$().${i}("${e}")`;return t.each((function(t,h){
          let a=o.data(h,i);if(!a)return void s(`${i} not initialized. Cannot call method ${r}`);let c=a[e];if(!c||'_'==e.charAt(0))return void s(`${r} is not a valid method`);let d=c.apply(a,n);l=void 0===l?d:l;
        })),void 0!==l?l:t;
      }(this,t,e):(l=t,this.each((function(t,e){
        let s=o.data(e,i);s?(s.option(l),s._init()):(s=new n(e,l),o.data(e,i,s));
      })),this);var l;
    });
  };
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e():t.EvEmitter=e();
}('undefined'!=typeof window?window:this,(function(){
  function t(){}let e=t.prototype;return e.on=function(t,e){
    if(!t||!e)return this;let i=this._events=this._events||{},s=i[t]=i[t]||[];return s.includes(e)||s.push(e),this;
  },e.once=function(t,e){
    if(!t||!e)return this;this.on(t,e);let i=this._onceEvents=this._onceEvents||{};return(i[t]=i[t]||{})[e]=!0,this;
  },e.off=function(t,e){
    let i=this._events&&this._events[t];if(!i||!i.length)return this;let s=i.indexOf(e);return-1!=s&&i.splice(s,1),this;
  },e.emitEvent=function(t,e){
    let i=this._events&&this._events[t];if(!i||!i.length)return this;i=i.slice(0),e=e||[];let s=this._onceEvents&&this._onceEvents[t];for(let n of i){
      s&&s[n]&&(this.off(t,n),delete s[n]),n.apply(this,e);
    }return this;
  },e.allOff=function(){
    return delete this._events,delete this._onceEvents,this;
  },t;
})),
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */
function(t,e){
  'object'==typeof module&&module.exports?module.exports=e():t.getSize=e();
}(window,(function(){
  function t(t){
    let e=parseFloat(t);return-1==t.indexOf('%')&&!isNaN(e)&&e;
  }let e=['paddingLeft','paddingRight','paddingTop','paddingBottom','marginLeft','marginRight','marginTop','marginBottom','borderLeftWidth','borderRightWidth','borderTopWidth','borderBottomWidth'];e.length;return function(i){
    if('string'==typeof i&&(i=document.querySelector(i)),!(i&&'object'==typeof i&&i.nodeType))return;let s=getComputedStyle(i);if('none'==s.display)return function(){
      let t={ width:0,
        height:0,
        innerWidth:0,
        innerHeight:0,
        outerWidth:0,
        outerHeight:0 };return e.forEach(((e) => {
        t[e]=0;
      })),t;
    }();let n={};n.width=i.offsetWidth,n.height=i.offsetHeight;let o=n.isBorderBox='border-box'==s.boxSizing;e.forEach(((t) => {
      let e=s[t],i=parseFloat(e);n[t]=isNaN(i)?0:i;
    }));let l=n.paddingLeft+n.paddingRight,r=n.paddingTop+n.paddingBottom,h=n.marginLeft+n.marginRight,a=n.marginTop+n.marginBottom,c=n.borderLeftWidth+n.borderRightWidth,d=n.borderTopWidth+n.borderBottomWidth,u=t(s.width);!1!==u&&(n.width=u+(o?0:l+c));let p=t(s.height);return!1!==p&&(n.height=p+(o?0:r+d)),n.innerWidth=n.width-(l+c),n.innerHeight=n.height-(r+d),n.outerWidth=n.width+h,n.outerHeight=n.height+a,n;
  };
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(t):t.fizzyUIUtils=e(t);
}(this,(function(t){
  let e={ extend:function(t,e){
      return Object.assign(t,e);
    },
    modulo:function(t,e){
      return(t%e+e)%e;
    },
    makeArray:function(t){
      if(Array.isArray(t))return t;if(null==t)return[];return'object'==typeof t&&'number'==typeof t.length?[...t]:[t];
    },
    removeFrom:function(t,e){
      let i=t.indexOf(e);-1!=i&&t.splice(i,1);
    },
    getParent:function(t,e){
      for(;t.parentNode&&t!=document.body;)if((t=t.parentNode).matches(e))return t;
    },
    getQueryElement:function(t){
      return'string'==typeof t?document.querySelector(t):t;
    },
    handleEvent:function(t){
      let e='on'+t.type;this[e]&&this[e](t);
    },
    filterFindElements:function(t,i){
      return(t=e.makeArray(t)).filter((t => t instanceof HTMLElement)).reduce(((t,e) => {
        if(!i)return t.push(e),t;e.matches(i)&&t.push(e);let s=e.querySelectorAll(i);return t=t.concat(...s);
      }),[]);
    },
    debounceMethod:function(t,e,i){
      i=i||100;let s=t.prototype[e],n=e+'Timeout';t.prototype[e]=function(){
        clearTimeout(this[n]);let t=arguments;this[n]=setTimeout((() => {
          s.apply(this,t),delete this[n];
        }),i);
      };
    },
    docReady:function(t){
      let e=document.readyState;'complete'==e||'interactive'==e?setTimeout(t):document.addEventListener('DOMContentLoaded',t);
    },
    toDashed:function(t){
      return t.replace(/(.)([A-Z])/g,(function(t,e,i){
        return e+'-'+i;
      })).toLowerCase();
    } },i=t.console;return e.htmlInit=function(s,n){
    e.docReady((function(){
      let o='data-'+e.toDashed(n),l=document.querySelectorAll(`[${o}]`),r=t.jQuery;[...l].forEach(((t) => {
        let e,l=t.getAttribute(o);try{
          e=l&&JSON.parse(l);
        }
        catch(e){
          return void(i&&i.error(`Error parsing ${o} on ${t.className}: ${e}`));
        }let h=new s(t,e);r&&r.data(t,n,h);
      }));
    }));
  },e;
})),
/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */
function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(t,require('ev-emitter')):t.Unidragger=e(t,t.EvEmitter);
}('undefined'!=typeof window?window:this,(function(t,e){
  function i(){}let s=i.prototype=Object.create(e.prototype);s.handleEvent=function(t){
    let e='on'+t.type;this[e]&&this[e](t);
  };let n,o,l=!1;'ontouchstart'in t?(l=!0,n='touchstart',o=['touchmove','touchend','touchcancel']):t.PointerEvent?(n='pointerdown',o=['pointermove','pointerup','pointercancel']):(n='mousedown',o=['mousemove','mouseup']),s.touchActionValue='none',s.bindHandles=function(){
    this._bindHandles('addEventListener',this.touchActionValue);
  },s.unbindHandles=function(){
    this._bindHandles('removeEventListener','');
  },s._bindHandles=function(e,i){
    this.handles.forEach(((s) => {
      s[e](n,this,{ passive:l }),s[e]('click',this),t.PointerEvent&&(s.style.touchAction=i);
    }));
  },s.bindActivePointerEvents=function(){
    o.forEach(((e) => {
      t.addEventListener(e,this);
    }));
  },s.unbindActivePointerEvents=function(){
    o.forEach(((e) => {
      t.removeEventListener(e,this);
    }));
  },s.withPointer=function(t,e){
    e.pointerId===this.pointerIdentifier&&this[t](e,e);
  },s.withTouch=function(t,e){
    let i;for(let t of e.changedTouches)t.identifier===this.pointerIdentifier&&(i=t);i&&this[t](e,i);
  },s.onmousedown=function(t){
    this.pointerDown(t,t);
  },s.ontouchstart=function(t){
    this.pointerDown(t,t.changedTouches[0]);
  },s.onpointerdown=function(t){
    this.pointerDown(t,t);
  };const r=['TEXTAREA','INPUT','SELECT','OPTION'],h=['radio','checkbox','button','submit','image','file'];return s.pointerDown=function(t,e){
    let i=r.includes(t.target.nodeName),s=h.includes(t.target.type),n=!i||s;!this.isPointerDown&&!t.button&&n&&(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDownPointer={ pageX:e.pageX,
      pageY:e.pageY },this.bindActivePointerEvents(),this.emitEvent('pointerDown',[t,e]));
  },s.onmousemove=function(t){
    this.pointerMove(t,t);
  },s.onpointermove=function(t){
    this.withPointer('pointerMove',t);
  },s.ontouchmove=function(t){
    this.withTouch('pointerMove',t);
  },s.pointerMove=function(t,e){
    let i={ x:e.pageX-this.pointerDownPointer.pageX,
      y:e.pageY-this.pointerDownPointer.pageY };this.emitEvent('pointerMove',[t,e,i]),!this.isDragging&&this.hasDragStarted(i)&&this.dragStart(t,e),this.isDragging&&this.dragMove(t,e,i);
  },s.hasDragStarted=function(t){
    return Math.abs(t.x)>3||Math.abs(t.y)>3;
  },s.dragStart=function(t,e){
    this.isDragging=!0,this.isPreventingClicks=!0,this.emitEvent('dragStart',[t,e]);
  },s.dragMove=function(t,e,i){
    this.emitEvent('dragMove',[t,e,i]);
  },s.onmouseup=function(t){
    this.pointerUp(t,t);
  },s.onpointerup=function(t){
    this.withPointer('pointerUp',t);
  },s.ontouchend=function(t){
    this.withTouch('pointerUp',t);
  },s.pointerUp=function(t,e){
    this.pointerDone(),this.emitEvent('pointerUp',[t,e]),this.isDragging?this.dragEnd(t,e):this.staticClick(t,e);
  },s.dragEnd=function(t,e){
    this.isDragging=!1,setTimeout((() => delete this.isPreventingClicks)),this.emitEvent('dragEnd',[t,e]);
  },s.pointerDone=function(){
    this.isPointerDown=!1,delete this.pointerIdentifier,this.unbindActivePointerEvents(),this.emitEvent('pointerDone');
  },s.onpointercancel=function(t){
    this.withPointer('pointerCancel',t);
  },s.ontouchcancel=function(t){
    this.withTouch('pointerCancel',t);
  },s.pointerCancel=function(t,e){
    this.pointerDone(),this.emitEvent('pointerCancel',[t,e]);
  },s.onclick=function(t){
    this.isPreventingClicks&&t.preventDefault();
  },s.staticClick=function(t,e){
    let i='mouseup'===t.type;i&&this.isIgnoringMouseUp||(this.emitEvent('staticClick',[t,e]),i&&(this.isIgnoringMouseUp=!0,setTimeout((() => {
      delete this.isIgnoringMouseUp;
    }),400)));
  },i;
})),
/*!
 * Flickity main
 * Cell, slide, animate
 */
function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(require('get-size')):(t.Flickity=t.Flickity||{},t.Flickity.Cell=e(t.getSize));
}('undefined'!=typeof window?window:this,(function(t){
  const e='flickity-cell';function i(t){
    this.element=t,this.element.classList.add(e),this.x=0,this.unselect();
  }let s=i.prototype;return s.destroy=function(){
    this.unselect(),this.element.classList.remove(e),this.element.style.transform='',this.element.removeAttribute('aria-hidden');
  },s.getSize=function(){
    this.size=t(this.element);
  },s.select=function(){
    this.element.classList.add('is-selected'),this.element.removeAttribute('aria-hidden');
  },s.unselect=function(){
    this.element.classList.remove('is-selected'),this.element.setAttribute('aria-hidden','true');
  },s.remove=function(){
    this.element.remove();
  },i;
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e():(t.Flickity=t.Flickity||{},t.Flickity.Slide=e());
}('undefined'!=typeof window?window:this,(function(){
  function t(t,e,i){
    this.beginMargin=t,this.endMargin=e,this.cellAlign=i,this.cells=[],this.outerWidth=0,this.height=0;
  }let e=t.prototype;return e.addCell=function(t){
    this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1===this.cells.length&&(this.x=t.x,this.firstMargin=t.size[this.beginMargin]);
  },e.updateTarget=function(){
    let t=this.getLastCell(),e=t?t.size[this.endMargin]:0,i=this.outerWidth-(this.firstMargin+e);this.target=this.x+this.firstMargin+i*this.cellAlign;
  },e.getLastCell=function(){
    return this.cells[this.cells.length-1];
  },e.select=function(){
    this.cells.forEach((t => t.select()));
  },e.unselect=function(){
    this.cells.forEach((t => t.unselect()));
  },e.getCellElements=function(){
    return this.cells.map((t => t.element));
  },t;
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(require('fizzy-ui-utils')):(t.Flickity=t.Flickity||{},t.Flickity.animatePrototype=e(t.fizzyUIUtils));
}('undefined'!=typeof window?window:this,(function(t){
  let e={ startAnimation:function(){
    this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate());
  },
  animate:function(){
    this.applyDragForce(),this.applySelectedAttraction();let t=this.x;this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating&&requestAnimationFrame((() => this.animate()));
  },
  positionSlider:function(){
    let e=this.x;this.isWrapping&&(e=t.modulo(e,this.slideableWidth)-this.slideableWidth,this.shiftWrapCells(e)),this.setTranslateX(e,this.isAnimating),this.dispatchScrollEvent();
  },
  setTranslateX:function(t,e){
    t+=this.cursorPosition,this.options.rightToLeft&&(t=-t);let i=this.getPositionValue(t);this.slider.style.transform=e?`translate3d(${i},0,0)`:`translateX(${i})`;
  },
  dispatchScrollEvent:function(){
    let t=this.slides[0];if(!t)return;let e=-this.x-t.target,i=e/this.slidesWidth;this.dispatchEvent('scroll',null,[i,e]);
  },
  positionSliderAtSelected:function(){
    this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,this.positionSlider());
  },
  getPositionValue:function(t){
    return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+'%':Math.round(t)+'px';
  },
  settle:function(t){
    !this.isPointerDown&&Math.round(100*this.x)===Math.round(100*t)&&this.restingFrames++,this.restingFrames>2&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent('settle',null,[this.selectedIndex]));
  },
  shiftWrapCells:function(t){
    let e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);let i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1);
  },
  _shiftCells:function(t,e,i){
    t.forEach(((t) => {
      let s=e>0?i:0;this._wrapShiftCell(t,s),e-=t.size.outerWidth;
    }));
  },
  _unshiftCells:function(t){
    t&&t.length&&t.forEach((t => this._wrapShiftCell(t,0)));
  },
  _wrapShiftCell:function(t,e){
    this._renderCellPosition(t,t.x+this.slideableWidth*e);
  },
  integratePhysics:function(){
    this.x+=this.velocity,this.velocity*=this.getFrictionFactor();
  },
  applyForce:function(t){
    this.velocity+=t;
  },
  getFrictionFactor:function(){
    return 1-this.options[this.isFreeScrolling?'freeScrollFriction':'friction'];
  },
  getRestingPosition:function(){
    return this.x+this.velocity/(1-this.getFrictionFactor());
  },
  applyDragForce:function(){
    if(!this.isDraggable||!this.isPointerDown)return;let t=this.dragX-this.x-this.velocity;this.applyForce(t);
  },
  applySelectedAttraction:function(){
    if(this.isDraggable&&this.isPointerDown||this.isFreeScrolling||!this.slides.length)return;let t=(-1*this.selectedSlide.target-this.x)*this.options.selectedAttraction;this.applyForce(t);
  } };return e;
})),function(t,e){
  if('object'==typeof module&&module.exports)module.exports=e(t,require('ev-emitter'),require('get-size'),require('fizzy-ui-utils'),require('./cell'),require('./slide'),require('./animate'));else{
    let i=t.Flickity;t.Flickity=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,i.Cell,i.Slide,i.animatePrototype);
  }
}('undefined'!=typeof window?window:this,(function(t,e,i,s,n,o,l){
  const{ getComputedStyle:r,console:h }=t;let{ jQuery:a }=t,c=0,d={};function u(t,e){
    let i=s.getQueryElement(t);if(i){
      if(this.element=i,this.element.flickityGUID){
        let t=d[this.element.flickityGUID];return t&&t.option(e),t;
      }a&&(this.$element=a(this.element)),this.options={ ...this.constructor.defaults },this.option(e),this._create();
    }
    else h&&h.error(`Bad element for Flickity: ${i||t}`);
  }u.defaults={ accessibility:!0,
    cellAlign:'center',
    freeScrollFriction:.075,
    friction:.28,
    namespaceJQueryEvents:!0,
    percentPosition:!0,
    resize:!0,
    selectedAttraction:.025,
    setGallerySize:!0 },u.create={};let p=u.prototype;Object.assign(p,e.prototype),p._create=function(){
    let{ resize:e,watchCSS:i,rightToLeft:s }=this.options,n=this.guid=++c;this.element.flickityGUID=n,d[n]=this,this.selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.beginMargin=s?'marginRight':'marginLeft',this.endMargin=s?'marginLeft':'marginRight',this.viewport=document.createElement('div'),this.viewport.className='flickity-viewport',this._createSlider(),this.focusableElems=[this.element],(e||i)&&t.addEventListener('resize',this);for(let t in this.options.on){
      let e=this.options.on[t];this.on(t,e);
    }for(let t in u.create)u.create[t].call(this);i?this.watchCSS():this.activate();
  },p.option=function(t){
    Object.assign(this.options,t);
  },p.activate=function(){
    if(this.isActive)return;this.isActive=!0,this.element.classList.add('flickity-enabled'),this.options.rightToLeft&&this.element.classList.add('flickity-rtl'),this.getSize();let t=this._filterFindCellElements(this.element.children);this.slider.append(...t),this.viewport.append(this.slider),this.element.append(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener('keydown',this)),this.emitEvent('activate'),this.selectInitialIndex(),this.isInitActivated=!0,this.dispatchEvent('ready');
  },p._createSlider=function(){
    let t=document.createElement('div');t.className='flickity-slider',this.slider=t;
  },p._filterFindCellElements=function(t){
    return s.filterFindElements(t,this.options.cellSelector);
  },p.reloadCells=function(){
    this.cells=this._makeCells(this.slider.children),this.positionCells(),this._updateWrapShiftCells(),this.setGallerySize();
  },p._makeCells=function(t){
    return this._filterFindCellElements(t).map((t => new n(t)));
  },p.getLastCell=function(){
    return this.cells[this.cells.length-1];
  },p.getLastSlide=function(){
    return this.slides[this.slides.length-1];
  },p.positionCells=function(){
    this._sizeCells(this.cells),this._positionCells(0);
  },p._positionCells=function(t){
    t=t||0,this.maxCellHeight=t&&this.maxCellHeight||0;let e=0;if(t>0){
      let i=this.cells[t-1];e=i.x+i.size.outerWidth;
    }this.cells.slice(t).forEach(((t) => {
      t.x=e,this._renderCellPosition(t,e),e+=t.size.outerWidth,this.maxCellHeight=Math.max(t.size.outerHeight,this.maxCellHeight);
    })),this.slideableWidth=e,this.updateSlides(),this._containSlides(),this.slidesWidth=this.cells.length?this.getLastSlide().target-this.slides[0].target:0;
  },p._renderCellPosition=function(t,e){
    let i=e*(this.options.rightToLeft?-1:1);this.options.percentPosition&&(i*=this.size.innerWidth/t.size.width);let s=this.getPositionValue(i);t.element.style.transform=`translateX( ${s} )`;
  },p._sizeCells=function(t){
    t.forEach((t => t.getSize()));
  },p.updateSlides=function(){
    if(this.slides=[],!this.cells.length)return;let{ beginMargin:t,endMargin:e }=this,i=new o(t,e,this.cellAlign);this.slides.push(i);let s=this._getCanCellFit();this.cells.forEach(((n,l) => {
      if(!i.cells.length)return void i.addCell(n);let r=i.outerWidth-i.firstMargin+(n.size.outerWidth-n.size[e]);s(l,r)||(i.updateTarget(),i=new o(t,e,this.cellAlign),this.slides.push(i)),i.addCell(n);
    })),i.updateTarget(),this.updateSelectedSlide();
  },p._getCanCellFit=function(){
    let{ groupCells:t }=this.options;if(!t)return() => !1;if('number'==typeof t){
      let e=parseInt(t,10);return t => t%e!=0;
    }let e=1,i='string'==typeof t&&t.match(/^(\d+)%$/);i&&(e=parseInt(i[1],10)/100);let s=(this.size.innerWidth+1)*e;return(t,e) => e<=s;
  },p._init=p.reposition=function(){
    this.positionCells(),this.positionSliderAtSelected();
  },p.getSize=function(){
    this.size=i(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign;
  };let f={ left:0,
    center:.5,
    right:1 };p.setCellAlign=function(){
    let{ cellAlign:t,rightToLeft:e }=this.options,i=f[t];this.cellAlign=void 0!==i?i:t,e&&(this.cellAlign=1-this.cellAlign);
  },p.setGallerySize=function(){
    if(!this.options.setGallerySize)return;let t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=`${t}px`;
  },p._updateWrapShiftCells=function(){
    if(this.isWrapping=this.getIsWrapping(),!this.isWrapping)return;this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);let t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1);let i=this.size.innerWidth-this.cursorPosition;this.afterShiftCells=this._getGapCells(i,0,1);
  },p.getIsWrapping=function(){
    let{ wrapAround:t }=this.options;if(!t||this.slides.length<2)return!1;if('fill'!==t)return!0;let e=this.slideableWidth-this.size.innerWidth;if(e>this.size.innerWidth)return!0;for(let t of this.cells)if(t.size.outerWidth>e)return!1;return!0;
  },p._getGapCells=function(t,e,i){
    let s=[];for(;t>0;){
      let n=this.cells[e];if(!n)break;s.push(n),e+=i,t-=n.size.outerWidth;
    }return s;
  },p._containSlides=function(){
    if(!(this.options.contain&&!this.isWrapping&&this.cells.length))return;let t=this.slideableWidth-this.getLastCell().size[this.endMargin];if(t<this.size.innerWidth)this.slides.forEach(((e) => {
      e.target=t*this.cellAlign;
    }));else{
      let e=this.cursorPosition+this.cells[0].size[this.beginMargin],i=t-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach(((t) => {
        t.target=Math.max(t.target,e),t.target=Math.min(t.target,i);
      }));
    }
  },p.dispatchEvent=function(t,e,i){
    let s=e?[e].concat(i):i;if(this.emitEvent(t,s),a&&this.$element){
      let s=t+=this.options.namespaceJQueryEvents?'.flickity':'';if(e){
        let i=new a.Event(e);i.type=t,s=i;
      }this.$element.trigger(s,i);
    }
  };const g=['dragStart','dragMove','dragEnd','pointerDown','pointerMove','pointerEnd','staticClick'];let m=p.emitEvent;p.emitEvent=function(t,e){
    if('staticClick'===t){
      let t=this.getParentCell(e[0].target),i=t&&t.element,s=t&&this.cells.indexOf(t);e=e.concat(i,s);
    }if(m.call(this,t,e),!g.includes(t)||!a||!this.$element)return;t+=this.options.namespaceJQueryEvents?'.flickity':'';let i=e.shift(0),s=new a.Event(i);s.type=t,this.$element.trigger(s,e);
  },p.select=function(t,e,i){
    if(!this.isActive)return;if(t=parseInt(t,10),this._wrapSelect(t),(this.isWrapping||e)&&(t=s.modulo(t,this.slides.length)),!this.slides[t])return;let n=this.selectedIndex;this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent('select',null,[t]),t!==n&&this.dispatchEvent('change',null,[t]);
  },p._wrapSelect=function(t){
    if(!this.isWrapping)return;const{ selectedIndex:e,slideableWidth:i,slides:{ length:n } }=this;if(!this.isDragSelect){
      let i=s.modulo(t,n),o=Math.abs(i-e),l=Math.abs(i+n-e),r=Math.abs(i-n-e);l<o?t+=n:r<o&&(t-=n);
    }t<0?this.x-=i:t>=n&&(this.x+=i);
  },p.previous=function(t,e){
    this.select(this.selectedIndex-1,t,e);
  },p.next=function(t,e){
    this.select(this.selectedIndex+1,t,e);
  },p.updateSelectedSlide=function(){
    let t=this.slides[this.selectedIndex];t&&(this.unselectSelectedSlide(),this.selectedSlide=t,t.select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0]);
  },p.unselectSelectedSlide=function(){
    this.selectedSlide&&this.selectedSlide.unselect();
  },p.selectInitialIndex=function(){
    let t=this.options.initialIndex;if(this.isInitActivated)return void this.select(this.selectedIndex,!1,!0);if(t&&'string'==typeof t){
      if(this.queryCell(t))return void this.selectCell(t,!1,!0);
    }let e=0;t&&this.slides[t]&&(e=t),this.select(e,!1,!0);
  },p.selectCell=function(t,e,i){
    let s=this.queryCell(t);if(!s)return;let n=this.getCellSlideIndex(s);this.select(n,e,i);
  },p.getCellSlideIndex=function(t){
    let e=this.slides.find((e => e.cells.includes(t)));return this.slides.indexOf(e);
  },p.getCell=function(t){
    for(let e of this.cells)if(e.element===t)return e;
  },p.getCells=function(t){
    return(t=s.makeArray(t)).map((t => this.getCell(t))).filter(Boolean);
  },p.getCellElements=function(){
    return this.cells.map((t => t.element));
  },p.getParentCell=function(t){
    let e=this.getCell(t);if(e)return e;let i=t.closest('.flickity-slider > *');return this.getCell(i);
  },p.getAdjacentCellElements=function(t,e){
    if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;let i=this.slides.length;if(1+2*t>=i)return this.getCellElements();let n=[];for(let o=e-t;o<=e+t;o++){
      let t=this.isWrapping?s.modulo(o,i):o,e=this.slides[t];e&&(n=n.concat(e.getCellElements()));
    }return n;
  },p.queryCell=function(t){
    if('number'==typeof t)return this.cells[t];return'string'==typeof t&&!t.match(/^[#.]?[\d/]/)&&(t=this.element.querySelector(t)),this.getCell(t);
  },p.uiChange=function(){
    this.emitEvent('uiChange');
  },p.onresize=function(){
    this.watchCSS(),this.resize();
  },s.debounceMethod(u,'onresize',150),p.resize=function(){
    if(!this.isActive||this.isAnimating||this.isDragging)return;this.getSize(),this.isWrapping&&(this.x=s.modulo(this.x,this.slideableWidth)),this.positionCells(),this._updateWrapShiftCells(),this.setGallerySize(),this.emitEvent('resize');let t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0);
  },p.watchCSS=function(){
    if(!this.options.watchCSS)return;r(this.element,':after').content.includes('flickity')?this.activate():this.deactivate();
  },p.onkeydown=function(t){
    let{ activeElement:e }=document,i=u.keyboardHandlers[t.key];this.options.accessibility&&e&&i&&this.focusableElems.some((t => e===t))&&i.call(this);
  },u.keyboardHandlers={ ArrowLeft:function(){
    this.uiChange(),this[this.options.rightToLeft?'next':'previous']();
  },
  ArrowRight:function(){
    this.uiChange(),this[this.options.rightToLeft?'previous':'next']();
  } },p.focus=function(){
    this.element.focus({ preventScroll:!0 });
  },p.deactivate=function(){
    this.isActive&&(this.element.classList.remove('flickity-enabled'),this.element.classList.remove('flickity-rtl'),this.unselectSelectedSlide(),this.cells.forEach((t => t.destroy())),this.viewport.remove(),this.element.append(...this.slider.children),this.options.accessibility&&(this.element.removeAttribute('tabIndex'),this.element.removeEventListener('keydown',this)),this.isActive=!1,this.emitEvent('deactivate'));
  },p.destroy=function(){
    this.deactivate(),t.removeEventListener('resize',this),this.allOff(),this.emitEvent('destroy'),a&&this.$element&&a.removeData(this.element,'flickity'),delete this.element.flickityGUID,delete d[this.guid];
  },Object.assign(p,l),u.data=function(t){
    if(t=s.getQueryElement(t))return d[t.flickityGUID];
  },s.htmlInit(u,'flickity');let{ jQueryBridget:v }=t;return a&&v&&v('flickity',u,a),u.setJQuery=function(t){
    a=t;
  },u.Cell=n,u.Slide=o,u;
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(t,require('./core'),require('unidragger'),require('fizzy-ui-utils')):t.Flickity=e(t,t.Flickity,t.Unidragger,t.fizzyUIUtils);
}('undefined'!=typeof window?window:this,(function(t,e,i,s){
  Object.assign(e.defaults,{ draggable:'>1',
    dragThreshold:3 });let n=e.prototype;function o(){
    return{ x:t.pageXOffset,
      y:t.pageYOffset };
  }return Object.assign(n,i.prototype),n.touchActionValue='',e.create.drag=function(){
    this.on('activate',this.onActivateDrag),this.on('uiChange',this._uiChangeDrag),this.on('deactivate',this.onDeactivateDrag),this.on('cellChange',this.updateDraggable),this.on('pointerDown',this.handlePointerDown),this.on('pointerUp',this.handlePointerUp),this.on('pointerDown',this.handlePointerDone),this.on('dragStart',this.handleDragStart),this.on('dragMove',this.handleDragMove),this.on('dragEnd',this.handleDragEnd),this.on('staticClick',this.handleStaticClick);
  },n.onActivateDrag=function(){
    this.handles=[this.viewport],this.bindHandles(),this.updateDraggable();
  },n.onDeactivateDrag=function(){
    this.unbindHandles(),this.element.classList.remove('is-draggable');
  },n.updateDraggable=function(){
    '>1'===this.options.draggable?this.isDraggable=this.slides.length>1:this.isDraggable=this.options.draggable,this.element.classList.toggle('is-draggable',this.isDraggable);
  },n._uiChangeDrag=function(){
    delete this.isFreeScrolling;
  },n.handlePointerDown=function(e){
    if(!this.isDraggable)return void this.bindActivePointerEvents(e);let i='touchstart'===e.type,s='touch'===e.pointerType,n=e.target.matches('input, textarea, select');i||s||n||e.preventDefault(),n||this.focus(),document.activeElement!==this.element&&document.activeElement.blur(),this.dragX=this.x,this.viewport.classList.add('is-pointer-down'),this.pointerDownScroll=o(),t.addEventListener('scroll',this),this.bindActivePointerEvents(e);
  },n.hasDragStarted=function(t){
    return Math.abs(t.x)>this.options.dragThreshold;
  },n.handlePointerUp=function(){
    delete this.isTouchScrolling,this.viewport.classList.remove('is-pointer-down');
  },n.handlePointerDone=function(){
    t.removeEventListener('scroll',this),delete this.pointerDownScroll;
  },n.handleDragStart=function(){
    this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),t.removeEventListener('scroll',this));
  },n.handleDragMove=function(t,e,i){
    if(!this.isDraggable)return;t.preventDefault(),this.previousDragX=this.dragX;let s=this.options.rightToLeft?-1:1;this.isWrapping&&(i.x%=this.slideableWidth);let n=this.dragStartPosition+i.x*s;if(!this.isWrapping){
      let t=Math.max(-this.slides[0].target,this.dragStartPosition);n=n>t?.5*(n+t):n;let e=Math.min(-this.getLastSlide().target,this.dragStartPosition);n=n<e?.5*(n+e):n;
    }this.dragX=n,this.dragMoveTime=new Date;
  },n.handleDragEnd=function(){
    if(!this.isDraggable)return;let{ freeScroll:t }=this.options;t&&(this.isFreeScrolling=!0);let e=this.dragEndRestingSelect();if(t&&!this.isWrapping){
      let t=this.getRestingPosition();this.isFreeScrolling=-t>this.slides[0].target&&-t<this.getLastSlide().target;
    }
    else t||e!==this.selectedIndex||(e+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.isWrapping,this.select(e),delete this.isDragSelect;
  },n.dragEndRestingSelect=function(){
    let t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),s=this._getClosestResting(t,e,-1);return i.distance<s.distance?i.index:s.index;
  },n._getClosestResting=function(t,e,i){
    let s=this.selectedIndex,n=1/0,o=this.options.contain&&!this.isWrapping?(t,e) => t<=e:(t,e) => t<e;for(;o(e,n)&&(s+=i,n=e,null!==(e=this.getSlideDistance(-t,s)));)e=Math.abs(e);return{ distance:n,
      index:s-i };
  },n.getSlideDistance=function(t,e){
    let i=this.slides.length,n=this.options.wrapAround&&i>1,o=n?s.modulo(e,i):e,l=this.slides[o];if(!l)return null;let r=n?this.slideableWidth*Math.floor(e/i):0;return t-(l.target+r);
  },n.dragEndBoostSelect=function(){
    if(void 0===this.previousDragX||!this.dragMoveTime||new Date-this.dragMoveTime>100)return 0;let t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return t>0&&e>0?1:t<0&&e<0?-1:0;
  },n.onscroll=function(){
    let t=o(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;(Math.abs(e)>3||Math.abs(i)>3)&&this.pointerDone();
  },e;
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(require('./core')):e(t.Flickity);
}('undefined'!=typeof window?window:this,(function(t){
  const e='http://www.w3.org/2000/svg';function i(t,e,i){
    this.increment=t,this.direction=e,this.isPrevious='previous'===t,this.isLeft='left'===e,this._create(i);
  }i.prototype._create=function(t){
    let e=this.element=document.createElement('button');e.className=`flickity-button flickity-prev-next-button ${this.increment}`;let i=this.isPrevious?'Previous':'Next';e.setAttribute('type','button'),e.setAttribute('aria-label',i),this.disable();let s=this.createSVG(i,t);e.append(s);
  },i.prototype.createSVG=function(t,i){
    let s=document.createElementNS(e,'svg');s.setAttribute('class','flickity-button-icon'),s.setAttribute('viewBox','0 0 100 100');let n=document.createElementNS(e,'title');n.append(t);let o=document.createElementNS(e,'path'),l=function(t){
      if('string'==typeof t)return t;let{ x0:e,x1:i,x2:s,x3:n,y1:o,y2:l }=t;return`M ${e}, 50\n    L ${i}, ${o+50}\n    L ${s}, ${l+50}\n    L ${n}, 50\n    L ${s}, ${50-l}\n    L ${i}, ${50-o}\n    Z`;
    }(i);return o.setAttribute('d',l),o.setAttribute('class','arrow'),this.isLeft||o.setAttribute('transform','translate(100, 100) rotate(180)'),s.append(n,o),s;
  },i.prototype.enable=function(){
    this.element.removeAttribute('disabled');
  },i.prototype.disable=function(){
    this.element.setAttribute('disabled',!0);
  },Object.assign(t.defaults,{ prevNextButtons:!0,
    arrowShape:{ x0:10,
      x1:60,
      y1:50,
      x2:70,
      y2:40,
      x3:30 } }),t.create.prevNextButtons=function(){
    if(!this.options.prevNextButtons)return;let{ rightToLeft:t,arrowShape:e }=this.options,s=t?'right':'left',n=t?'left':'right';this.prevButton=new i('previous',s,e),this.nextButton=new i('next',n,e),this.focusableElems.push(this.prevButton.element),this.focusableElems.push(this.nextButton.element),this.handlePrevButtonClick=() => {
      this.uiChange(),this.previous();
    },this.handleNextButtonClick=() => {
      this.uiChange(),this.next();
    },this.on('activate',this.activatePrevNextButtons),this.on('select',this.updatePrevNextButtons);
  };let s=t.prototype;return s.updatePrevNextButtons=function(){
    let t=this.slides.length?this.slides.length-1:0;this.updatePrevNextButton(this.prevButton,0),this.updatePrevNextButton(this.nextButton,t);
  },s.updatePrevNextButton=function(t,e){
    if(this.isWrapping&&this.slides.length>1)return void t.enable();let i=this.selectedIndex!==e;t[i?'enable':'disable'](),!i&&document.activeElement===t.element&&this.focus();
  },s.activatePrevNextButtons=function(){
    this.prevButton.element.addEventListener('click',this.handlePrevButtonClick),this.nextButton.element.addEventListener('click',this.handleNextButtonClick),this.element.append(this.prevButton.element,this.nextButton.element),this.on('deactivate',this.deactivatePrevNextButtons);
  },s.deactivatePrevNextButtons=function(){
    this.prevButton.element.remove(),this.nextButton.element.remove(),this.prevButton.element.removeEventListener('click',this.handlePrevButtonClick),this.nextButton.element.removeEventListener('click',this.handleNextButtonClick),this.off('deactivate',this.deactivatePrevNextButtons);
  },t.PrevNextButton=i,t;
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(require('./core'),require('fizzy-ui-utils')):e(t.Flickity,t.fizzyUIUtils);
}('undefined'!=typeof window?window:this,(function(t,e){
  function i(){
    this.holder=document.createElement('div'),this.holder.className='flickity-page-dots',this.dots=[];
  }i.prototype.setDots=function(t){
    let e=t-this.dots.length;e>0?this.addDots(e):e<0&&this.removeDots(-e);
  },i.prototype.addDots=function(t){
    let e=new Array(t).fill().map(((t,e) => {
      let i=document.createElement('button');i.setAttribute('type','button');let s=e+1+this.dots.length;return i.className='flickity-page-dot',i.textContent=`View slide ${s}`,i;
    }));this.holder.append(...e),this.dots=this.dots.concat(e);
  },i.prototype.removeDots=function(t){
    this.dots.splice(this.dots.length-t,t).forEach((t => t.remove()));
  },i.prototype.updateSelected=function(t){
    this.selectedDot&&(this.selectedDot.classList.remove('is-selected'),this.selectedDot.removeAttribute('aria-current')),this.dots.length&&(this.selectedDot=this.dots[t],this.selectedDot.classList.add('is-selected'),this.selectedDot.setAttribute('aria-current','step'));
  },t.PageDots=i,Object.assign(t.defaults,{ pageDots:!0 }),t.create.pageDots=function(){
    this.options.pageDots&&(this.pageDots=new i,this.handlePageDotsClick=this.onPageDotsClick.bind(this),this.on('activate',this.activatePageDots),this.on('select',this.updateSelectedPageDots),this.on('cellChange',this.updatePageDots),this.on('resize',this.updatePageDots),this.on('deactivate',this.deactivatePageDots));
  };let s=t.prototype;return s.activatePageDots=function(){
    this.pageDots.setDots(this.slides.length),this.focusableElems.push(...this.pageDots.dots),this.pageDots.holder.addEventListener('click',this.handlePageDotsClick),this.element.append(this.pageDots.holder);
  },s.onPageDotsClick=function(t){
    let e=this.pageDots.dots.indexOf(t.target);-1!==e&&(this.uiChange(),this.select(e));
  },s.updateSelectedPageDots=function(){
    this.pageDots.updateSelected(this.selectedIndex);
  },s.updatePageDots=function(){
    this.pageDots.dots.forEach(((t) => {
      e.removeFrom(this.focusableElems,t);
    })),this.pageDots.setDots(this.slides.length),this.focusableElems.push(...this.pageDots.dots);
  },s.deactivatePageDots=function(){
    this.pageDots.holder.remove(),this.pageDots.holder.removeEventListener('click',this.handlePageDotsClick);
  },t.PageDots=i,t;
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(require('./core')):e(t.Flickity);
}('undefined'!=typeof window?window:this,(function(t){
  function e(t,e){
    this.autoPlay=t,this.onTick=e,this.state='stopped',this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this);
  }e.prototype.play=function(){
    if('playing'===this.state)return;document.hidden?document.addEventListener('visibilitychange',this.onVisibilityPlay):(this.state='playing',document.addEventListener('visibilitychange',this.onVisibilityChange),this.tick());
  },e.prototype.tick=function(){
    if('playing'!==this.state)return;let t='number'==typeof this.autoPlay?this.autoPlay:3e3;this.clear(),this.timeout=setTimeout((() => {
      this.onTick(),this.tick();
    }),t);
  },e.prototype.stop=function(){
    this.state='stopped',this.clear(),document.removeEventListener('visibilitychange',this.onVisibilityChange);
  },e.prototype.clear=function(){
    clearTimeout(this.timeout);
  },e.prototype.pause=function(){
    'playing'===this.state&&(this.state='paused',this.clear());
  },e.prototype.unpause=function(){
    'paused'===this.state&&this.play();
  },e.prototype.visibilityChange=function(){
    this[document.hidden?'pause':'unpause']();
  },e.prototype.visibilityPlay=function(){
    this.play(),document.removeEventListener('visibilitychange',this.onVisibilityPlay);
  },Object.assign(t.defaults,{ pauseAutoPlayOnHover:!0 }),t.create.player=function(){
    this.player=new e(this.options.autoPlay,(() => {
      this.next(!0);
    })),this.on('activate',this.activatePlayer),this.on('uiChange',this.stopPlayer),this.on('pointerDown',this.stopPlayer),this.on('deactivate',this.deactivatePlayer);
  };let i=t.prototype;return i.activatePlayer=function(){
    this.options.autoPlay&&(this.player.play(),this.element.addEventListener('mouseenter',this));
  },i.playPlayer=function(){
    this.player.play();
  },i.stopPlayer=function(){
    this.player.stop();
  },i.pausePlayer=function(){
    this.player.pause();
  },i.unpausePlayer=function(){
    this.player.unpause();
  },i.deactivatePlayer=function(){
    this.player.stop(),this.element.removeEventListener('mouseenter',this);
  },i.onmouseenter=function(){
    this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener('mouseleave',this));
  },i.onmouseleave=function(){
    this.player.unpause(),this.element.removeEventListener('mouseleave',this);
  },t.Player=e,t;
})),function(t,e){
  'object'==typeof module&&module.exports?module.exports=e(require('./core'),require('fizzy-ui-utils')):e(t.Flickity,t.fizzyUIUtils);
}('undefined'!=typeof window?window:this,(function(t,e){
  let i=t.prototype;return i.insert=function(t,e){
    let i=this._makeCells(t);if(!i||!i.length)return;let s=this.cells.length;e=void 0===e?s:e;let n=function(t){
        let e=document.createDocumentFragment();return t.forEach((t => e.appendChild(t.element))),e;
      }(i),o=e===s;if(o)this.slider.appendChild(n);else{
      let t=this.cells[e].element;this.slider.insertBefore(n,t);
    }if(0===e)this.cells=i.concat(this.cells);else if(o)this.cells=this.cells.concat(i);else{
      let t=this.cells.splice(e,s-e);this.cells=this.cells.concat(i).concat(t);
    }this._sizeCells(i),this.cellChange(e),this.positionSliderAtSelected();
  },i.append=function(t){
    this.insert(t,this.cells.length);
  },i.prepend=function(t){
    this.insert(t,0);
  },i.remove=function(t){
    let i=this.getCells(t);if(!i||!i.length)return;let s=this.cells.length-1;i.forEach(((t) => {
      t.remove();let i=this.cells.indexOf(t);s=Math.min(i,s),e.removeFrom(this.cells,t);
    })),this.cellChange(s),this.positionSliderAtSelected();
  },i.cellSizeChange=function(t){
    let e=this.getCell(t);if(!e)return;e.getSize();let i=this.cells.indexOf(e);this.cellChange(i);
  },i.cellChange=function(t){
    let e=this.selectedElement;this._positionCells(t),this._updateWrapShiftCells(),this.setGallerySize();let i=this.getCell(e);i&&(this.selectedIndex=this.getCellSlideIndex(i)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent('cellChange',[t]),this.select(this.selectedIndex);
  },t;
}));
/*!
 * Flickity asNavFor v3.0.0
 * enable asNavFor for Flickity
 */
!function(e,t){
  'object'==typeof module&&module.exports?module.exports=t(require('flickity'),require('fizzy-ui-utils')):e.Flickity=t(e.Flickity,e.fizzyUIUtils);
}(window,function(e,t){
  e.create.asNavFor=function(){
    this.on('activate',this.activateAsNavFor),this.on('deactivate',this.deactivateAsNavFor),this.on('destroy',this.destroyAsNavFor);let e=this.options.asNavFor;e&&setTimeout(() => {
      this.setNavCompanion(e);
    });
  };let n=e.prototype;return n.setNavCompanion=function(n){
    n=t.getQueryElement(n);let i=e.data(n);i&&i!==this&&(this.navCompanion=i,this.onNavCompanionSelect=(() => {
      this.navCompanionSelect();
    }),i.on('select',this.onNavCompanionSelect),this.on('staticClick',this.onNavStaticClick),this.navCompanionSelect(!0));
  },n.navCompanionSelect=function(e){
    let t=this.navCompanion&&this.navCompanion.selectedCells;if(!t)return;let n=t[0],i=this.navCompanion.cells.indexOf(n),o=i+t.length-1,a=Math.floor((s=i,l=o,c=this.navCompanion.cellAlign,(l-s)*c+s));var s,l,c;if(this.selectCell(a,!1,e),this.removeNavSelectedElements(),a>=this.cells.length)return;let v=this.cells.slice(i,o+1);this.navSelectedElements=v.map(e => e.element),this.changeNavSelectedClass('add');
  },n.changeNavSelectedClass=function(e){
    this.navSelectedElements.forEach(function(t){
      t.classList[e]('is-nav-selected');
    });
  },n.activateAsNavFor=function(){
    this.navCompanionSelect(!0);
  },n.removeNavSelectedElements=function(){
    this.navSelectedElements&&(this.changeNavSelectedClass('remove'),delete this.navSelectedElements);
  },n.onNavStaticClick=function(e,t,n,i){
    'number'==typeof i&&this.navCompanion.selectCell(i);
  },n.deactivateAsNavFor=function(){
    this.removeNavSelectedElements();
  },n.destroyAsNavFor=function(){
    this.navCompanion&&(this.navCompanion.off('select',this.onNavCompanionSelect),this.off('staticClick',this.onNavStaticClick),delete this.navCompanion);
  },e;
});
/*!
 * Flickity is-next/is-previous v3.0.0
 */
!function(e,i){
  'object'==typeof module&&module.exports?module.exports=i(require('flickity'),require('fizzy-ui-utils')):e.Flickity=i(e.Flickity,e.fizzyUIUtils);
}(window,function(e,i){
  return e.create._createPrevNextCells=function(){
    this.on('select',this._setPrevNextCells);
  },e.prototype._setPrevNextCells=function(){
    function e(e,i,t){
      e&&e.getCellElements().forEach(function(e){
        e.classList[i](t);
      });
    }e(this.previousSlide,'remove','is-previous'),e(this.nextSlide,'remove','is-next');var i=fizzyUIUtils.modulo(this.selectedIndex-1,this.slides.length),t=fizzyUIUtils.modulo(this.selectedIndex+1,this.slides.length);this.previousSlide=this.slides[i],this.nextSlide=this.slides[t],e(this.previousSlide,'add','is-previous'),e(this.nextSlide,'add','is-next');
  },e;
});
/**
 * Flickity fade v2.0.0
 * Fade between Flickity slides
*/
!function(e,t){
  'object'==typeof module&&module.exports?module.exports=t(require('flickity'),require('fizzy-ui-utils')):t(e.Flickity,e.fizzyUIUtils);
}('undefined'!=typeof window?window:this,function(e,n){
  let t=e.Slide;t.prototype.renderFadePosition=function(){},t.prototype.setOpacity=function(t){
    this.cells.forEach((e) => {
      e.element.style.opacity=t;
    });
  },e.create.fade=function(){
    this.fadeIndex=this.selectedIndex,this.prevSelectedIndex=this.selectedIndex,this.on('select',this.onSelectFade),this.on('dragEnd',this.onDragEndFade),this.on('settle',this.onSettleFade),this.on('activate',this.onActivateFade),this.on('deactivate',this.onDeactivateFade);
  };let i=e.prototype,s=i.updateSlides;i.updateSlides=function(){
    s.apply(this,arguments),this.options.fade&&this.slides.forEach((e,t) => {
      var i=e.target-e.x,s=e.cells[0].x;e.cells.forEach((e) => {
        var t=e.x-s-i;this._renderCellPosition(e,t);
      });t=t===this.selectedIndex?1:0;e.setOpacity(t);
    });
  },i.onSelectFade=function(){
    this.fadeIndex=Math.min(this.prevSelectedIndex,this.slides.length-1),this.prevSelectedIndex=this.selectedIndex;
  },i.onSettleFade=function(){
    delete this.didDragEnd,this.options.fade&&(this.selectedSlide.setOpacity(1),this.slides[this.fadeIndex]&&this.fadeIndex!==this.selectedIndex&&this.slides[this.fadeIndex].setOpacity(0));
  },i.onDragEndFade=function(){
    this.didDragEnd=!0;
  },i.onActivateFade=function(){
    this.options.fade&&this.element.classList.add('is-fade');
  },i.onDeactivateFade=function(){
    this.options.fade&&(this.element.classList.remove('is-fade'),this.slides.forEach((e) => {
      e.setOpacity('');
    }));
  };let d=i.positionSlider;i.positionSlider=function(){
    this.options.fade?(this.fadeSlides(),this.dispatchScrollEvent()):d.apply(this,arguments);
  };let a=i.positionSliderAtSelected;i.positionSliderAtSelected=function(){
    this.options.fade&&this.setTranslateX(0),a.apply(this,arguments);
  },i.fadeSlides=function(){
    if(!(this.slides.length<2)){
      var s=this.getFadeIndexes();let e=this.slides[s.a],t=this.slides[s.b];var d=this.wrapDifference(e.target,t.target),n=this.wrapDifference(e.target,-this.x);n/=d,e.setOpacity(1-n),t.setOpacity(n);let i=s.a;this.isDragging&&(i=.5<n?s.a:s.b),void 0!==this.fadeHideIndex&&this.fadeHideIndex!==i&&this.fadeHideIndex!==s.a&&this.fadeHideIndex!==s.b&&this.slides[this.fadeHideIndex].setOpacity(0),this.fadeHideIndex=i;
    }
  },i.getFadeIndexes=function(){
    return this.isDragging||this.didDragEnd?this.options.wrapAround?this.getFadeDragWrapIndexes():this.getFadeDragLimitIndexes():{ a:this.fadeIndex,
      b:this.selectedIndex };
  },i.getFadeDragWrapIndexes=function(){
    let e=this.slides.map(function(e,t){
        return this.getSlideDistance(-this.x,t);
      },this),t=e.map(function(e){
        return Math.abs(e);
      });var i=Math.min(...t),s=t.indexOf(i),d=e[s],i=this.slides.length,d=0<=d?1:-1;return{ a:s,
      b:n.modulo(s+d,i) };
  },i.getFadeDragLimitIndexes=function(){
    let t=0;for(let e=0;e<this.slides.length-1;e++){
      var i=this.slides[e];if(-this.x<i.target)break;t=e;
    }return{ a:t,
      b:t+1 };
  },i.wrapDifference=function(e,t){
    let i=t-e;if(!this.options.wrapAround)return i;t=i+this.slideableWidth,e=i-this.slideableWidth;return Math.abs(t)<Math.abs(i)&&(i=t),Math.abs(e)<Math.abs(i)&&(i=e),i;
  };let h=i._updateWrapShiftCells;i._updateWrapShiftCells=function(){
    this.options.fade?this.isWrapping=this.getIsWrapping():h.apply(this,arguments);
  };let l=i.shiftWrapCells;return i.shiftWrapCells=function(){
    this.options.fade||l.apply(this,arguments);
  },e;
});
